export default {
      id: "log-out-usage",
      viewBox: "0 0 21 26",
      url: "/" + "sprite.svg#log-out",
      toString: function () {
        return this.url;
      }
    }